import { HTMLAttributes } from 'react';

type CardElement = 'div' | 'section' | 'article' | 'li';

interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Elemento renderizado, para a semântica certa no contexto. Padrão: `div`. */
  as?: CardElement;
  /**
   * Aplica o padding padrão de 20px (`p-5`). Para outro padding, passe
   * `padded={false}` e o padding desejado no `className`: duas classes de
   * padding na mesma lista não têm precedência garantida no Tailwind.
   */
  padded?: boolean;
}

/** Superfície branca da nova identidade: raio de 12px, sombra de card e sem borda. */
export default function Card({ as: Element = 'div', padded = true, className, ...props }: CardProps) {
  const classes = ['bg-brand-white rounded-jj-lg shadow-jj-01', padded && 'p-5', className]
    .filter(Boolean)
    .join(' ');

  return <Element className={classes} {...props} />;
}
